export const ALL_ASSETS = [
    'BTCUSDT',
    'ETHUSDT',
    'LTCUSDT',
    'XRPUSDT',
    'BCHUSDT',
    'HBARUSDT',
    'USDCUSDT',
    'XLMUSDT',
    'AVAXUSDT',
    'ETCUSDT',
    'GOLDUSD',
    'GOLDEURO'
];
